var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78516 5.76514C5.03125 5.51904 5.44141 5.51904 5.6875 5.76514L6.97266 7.07764L8.28516 5.76514C8.53125 5.51904 8.94141 5.51904 9.1875 5.76514C9.46094 6.03857 9.46094 6.44873 9.1875 6.69482L7.90234 7.97998L9.1875 9.26514C9.46094 9.53857 9.46094 9.94873 9.1875 10.1948C8.94141 10.4683 8.53125 10.4683 8.28516 10.1948L6.97266 8.90967L5.6875 10.1948C5.44141 10.4683 5.03125 10.4683 4.78516 10.1948C4.51172 9.94873 4.51172 9.53857 4.78516 9.26514L6.07031 7.97998L4.78516 6.69482C4.51172 6.44873 4.51172 6.03857 4.78516 5.76514ZM14 7.97998C14 11.8628 10.8555 14.98 7 14.98C3.11719 14.98 0 11.8628 0 7.97998C0 4.12451 3.11719 0.97998 7 0.97998C10.8555 0.97998 14 4.12451 14 7.97998ZM7 2.29248C3.85547 2.29248 1.3125 4.86279 1.3125 7.97998C1.3125 11.1245 3.85547 13.6675 7 13.6675C10.1172 13.6675 12.6875 11.1245 12.6875 7.97998C12.6875 4.86279 10.1172 2.29248 7 2.29248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleXmark);
export default __webpack_public_path__ + "static/media/circle-xmark.9514117a42b20c15816498d673c8e201.svg";
export { ForwardRef as ReactComponent };